export default __webpack_public_path__ + "static/media/pcard1.343f62b3.webp";